module.exports = __webpack_public_path__ + "img/sj.409d0b6c.svg";